import CategoriesItem from '@/components/ui/categories/item'
import styles from './styles.module.css'
import { memo } from 'react'

const Categories = ({ categories, onItemClick, onIsCurrent }) => {
  return (
    <div className={styles.categoriesContainer}>
      <div className={styles.categoriesRow}>
        {categories?.map(({ label, data }, index) => (
          <CategoriesItem
            key={index}
            label={label}
            isCurrent={onIsCurrent(data) === true}
            onClick={() => onItemClick(data)}
            length={categories.length}
            isFirst={index === 0}
          />
        ))}
      </div>
    </div>
  )
}

export default memo(Categories)
